import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Container } from 'semantic-ui-react';

import NewsItem from './NewsItem';

class NewsList extends React.PureComponent {
  static propTypes = {
    newsItemsObjects: PropTypes.array,
    themeType: PropTypes.string.isRequired,
    themeId: PropTypes.string.isRequired,
    getPositionTarget: PropTypes.func,
  };

  static defaultProps = {
    newsItemsObjects: [],
    getPositionTarget: () => null,
  }

  render() {
    return (
      <Container>
        {_.map(_.reverse(_.sortBy(this.props.newsItemsObjects, e => e.key)), item => (
          <NewsItem
            key={item.key}
            newsItemObject={item}
            themeType={this.props.themeType}
            themeId={this.props.themeId}
            getPositionTarget={position => this.props.getPositionTarget(position)}
          />))}
      </Container>
    );
  }
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/components/News/NewsList.js